/**
 * Electron 渲染进程 API 封装
 */

export function isElectron() {
  return Boolean(window.electronAPI?.isElectron)
}

export function getElectronAPI() {
  return window.electronAPI || null
}

export function quitApp() {
  const api = getElectronAPI()
  if (api) {
    api.quitApp()
    return true
  }
  return false
}

/** 订阅自动更新事件，返回取消订阅函数 */
export function subscribeUpdateEvents(handlers = {}) {
  const api = getElectronAPI()
  if (!api) return () => {}

  const unsubscribes = []
  const pairs = [
    ['onUpdateAvailable', handlers.onAvailable],
    ['onUpdateDownloadProgress', handlers.onDownloadProgress],
    ['onUpdateDownloaded', handlers.onDownloaded],
    ['onUpdateError', handlers.onError]
  ]

  pairs.forEach(([method, handler]) => {
    if (typeof handler === 'function' && typeof api[method] === 'function') {
      unsubscribes.push(api[method](handler))
    }
  })

  return () => unsubscribes.forEach((unsubscribe) => unsubscribe())
}

/** 开始下载更新包 */
export function downloadUpdate() {
  const api = getElectronAPI()
  if (api?.downloadUpdate) {
    return api.downloadUpdate()
  }
  return Promise.resolve()
}

/** 立即安装已下载的更新并重启 */
export function installUpdate() {
  const api = getElectronAPI()
  if (api?.installUpdate) {
    return api.installUpdate()
  }
  return Promise.resolve()
}
